export default {
  averageRating: 'Vidutinis tiekėjo įvertinimas: {rating}',
  dishName: 'Patiekalo Pavadinimas',
  avgRating: 'Vidutinis Įvertinimas',
  ratingsCount: 'Įvertinimų kiekis',
  noComments: 'Nėra Komentarų',
  tooltip: 'Spustelėjus ant patiekalo, galima pamatyti komentarus.',
  nothingFound: 'Įvertinimų dar nėra',
  nothingFoundBody: 'Laikui bėgant jų atsiras.',
  ratingBtnNothingOrdered: 'Atsiliepimą galima palikti tik užsisakius iš šio tiekėjo.',
  ratingBtnAlreadyRated: 'Atsiliepimas jau paliktas.',
  ratingBtnLunchNotHappenedYet: 'Atsiliepimą galima palikti tik po pietų.',
};
